class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
    this.regionModalOpenedByValidation = false;

    this.setupEventListeners();

    // BLINDAGEM (fix Safari): a validação de região é um enxerto custom (override de
    // history.pushState, MutationObservers, localStorage). Se QUALQUER parte dela lançar
    // exceção — como acontece em alguns Safari — ela NÃO pode derrubar a busca. Isolando
    // num try/catch, o custom element sempre "sobe" e a busca do Dawn segue funcionando.
    try {
      this.setupRegionValidation();
    } catch (e) {
      console.error('[predictive-search] validação de região falhou; busca segue normal:', e);
    }
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  setupRegionValidation() {
    // Interceptar formulários de filtro ANTES de tudo
    this.interceptFilterForms();

    // Listener para detectar mudanças na URL (navegação do browser)
    window.addEventListener('popstate', this.checkRegionParam.bind(this));

    // Observer para detectar mudanças na URL sem recarregar a página
    this.setupUrlObserver();

    // Interceptar tentativas de fechamento do modal
    this.interceptModalClose();

    // Interceptar buscas para preservar região
    this.interceptSearchActions();

    // Observar erro de carregamento de produto
    this.setupErrorObserver();

    // Verificar parâmetro region_id na inicialização
    this.checkRegionParam();
  }

  interceptFilterForms() {
    const waitForFiltersAndIntercept = () => {
      const filterForms = document.querySelectorAll('facet-filters-form form');

      if (filterForms.length > 0) {
        filterForms.forEach(form => {
          form.addEventListener('submit', (e) => {
            this.preserveRegionInFilterForm(form);
          });
        });
      } else {
        setTimeout(waitForFiltersAndIntercept, 100);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', waitForFiltersAndIntercept);
    } else {
      waitForFiltersAndIntercept();
    }
  }

  preserveRegionInFilterForm(form) {
    const currentRegion = this.getCurrentRegionId();

    if (currentRegion) {
      let regionInput = form.querySelector('input[name="region_id"]');
      if (!regionInput) {
        regionInput = document.createElement('input');
        regionInput.type = 'hidden';
        regionInput.name = 'region_id';
        form.appendChild(regionInput);
      }
      regionInput.value = currentRegion;
    }
  }

  interceptModalClose() {
    // Interceptar cliques no botão de fechar do modal
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('region-selector-modal__close') && this.regionModalOpenedByValidation) {
        event.preventDefault();
        event.stopPropagation();

        // Verificar se ainda precisa manter o modal aberto
        const urlParams = new URLSearchParams(window.location.search);
        const regionId = urlParams.get('region_id');
        const isRegionIdInvalid = !regionId || regionId === 'null' || regionId === 'undefined' || regionId.trim() === '';

        if (isRegionIdInvalid) {
          // Ainda não há region_id válido, manter modal aberto
          setTimeout(() => {
            this.openRegionSelector();
          }, 10);
        } else {
          // Há region_id válido, permitir fechamento
          this.regionModalOpenedByValidation = false;
        }
      }
    });
  }

  interceptSearchActions() {
    // Salvar região antes de qualquer ação de busca
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function(state, title, url) {
      this.preserveRegionBeforeNavigation(url);
      return originalPushState.apply(history, arguments);
    }.bind(this);

    history.replaceState = function(state, title, url) {
      this.preserveRegionBeforeNavigation(url);
      return originalReplaceState.apply(history, arguments);
    }.bind(this);

    // Interceptar envios de formulários de busca
    document.addEventListener('submit', (event) => {
      if (event.target.querySelector('input[name="q"]')) {
        this.preserveRegionInSearch(event.target);
      }
    });
  }

  preserveRegionBeforeNavigation(url) {
    const currentRegion = this.getCurrentRegionId();
    if (currentRegion && url) {
      const urlObj = new URL(url, window.location.origin);
      if (!urlObj.searchParams.has('region_id')) {
        urlObj.searchParams.set('region_id', currentRegion);
        arguments[2] = urlObj.toString();
      }
    }
  }

  preserveRegionInSearch(form) {
    const currentRegion = this.getCurrentRegionId();
    if (currentRegion) {
      // Verificar se já existe um input hidden para region_id
      let regionInput = form.querySelector('input[name="region_id"]');
      if (!regionInput) {
        regionInput = document.createElement('input');
        regionInput.type = 'hidden';
        regionInput.name = 'region_id';
        form.appendChild(regionInput);
      }
      regionInput.value = currentRegion;
    }
  }

  setupUrlObserver() {
    // Salvar URL inicial para comparação
    this.lastUrl = window.location.href;
    this.lastRegionId = new URLSearchParams(window.location.search).get('region_id');

    // Usar MutationObserver para detectar mudanças no DOM que possam indicar mudança de URL
    this.observer = new MutationObserver(() => {
      if (this.lastUrl !== window.location.href) {
        const currentRegionId = new URLSearchParams(window.location.search).get('region_id');

        // Verificar se region_id foi removido completamente da URL
        if (this.lastRegionId && !currentRegionId) {
          this.handleRegionIdRemoval();
        }

        this.lastUrl = window.location.href;
        this.lastRegionId = currentRegionId;
        this.checkRegionParam();
      }
    });

    // Observar mudanças no body
    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  handleRegionIdRemoval() {
    // Region_ID foi removido completamente da URL
    // Limpar localStorage para permitir nova seleção
    const storedRegion = localStorage.getItem('selectedRegion');
    if (storedRegion) {
      localStorage.removeItem('selectedRegion');
    }

    // Marcar que o modal foi aberto pela nossa validação
    this.regionModalOpenedByValidation = true;

    // Abrir modal para seleção de nova região
    setTimeout(() => {
      this.openRegionSelector();
    }, 100);
  }

  setupErrorObserver() {
    // Observar o elemento de erro de carregamento
    const errorElement = document.getElementById('error-loading');

    if (errorElement) {
      // Observer para detectar quando o erro se torna visível
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            const isVisible = errorElement.style.display === 'block' ||
                            errorElement.style.display === '' &&
                            window.getComputedStyle(errorElement).display !== 'none';

            if (isVisible) {
              this.handleProductLoadError();
            }
          }
        });
      });

      observer.observe(errorElement, {
        attributes: true,
        attributeFilter: ['style']
      });

      // Verificar se já está visível na inicialização
      const isVisible = errorElement.style.display === 'block' ||
                       (errorElement.style.display === '' &&
                        window.getComputedStyle(errorElement).display !== 'none');

      if (isVisible) {
        this.handleProductLoadError();
      }
    }

    // Observer alternativo usando MutationObserver no DOM
    const domObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            const errorEl = node.id === 'error-loading' ? node : node.querySelector('#error-loading');
            if (errorEl && errorEl.style.display === 'block') {
              this.handleProductLoadError();
            }
          }
        });
      });
    });

    domObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  handleProductLoadError() {
    // Erro de carregamento detectado - problema com região
    console.log('Erro de carregamento detectado - abrindo modal de região');

    // Limpar localStorage para forçar nova seleção
    const storedRegion = localStorage.getItem('selectedRegion');
    if (storedRegion) {
      localStorage.removeItem('selectedRegion');
    }

    // Remover region_id da URL também
    const url = new URL(window.location);
    url.searchParams.delete('region_id');
    window.history.replaceState({}, '', url.toString());

    // Marcar que o modal foi aberto pela nossa validação
    this.regionModalOpenedByValidation = true;

    // Abrir modal para seleção de região
    setTimeout(() => {
      this.openRegionSelector();
    }, 500); // Delay maior para garantir que o erro foi processado
  }

  checkRegionParam() {
    const urlParams = new URLSearchParams(window.location.search);
    const regionId = urlParams.get('region_id');
    const storedRegion = localStorage.getItem('selectedRegion');

    // Verificar se estamos numa página de busca ou resultados de busca
    const isSearchPage = window.location.pathname.includes('/search') ||
                        window.location.pathname.includes('/products') ||
                        urlParams.has('q') ||
                        urlParams.has('psq') ||
                        document.querySelector('input[name="q"]');

    // Verificar se estamos numa página de coleção com filtros
    const isCollectionPage = window.location.pathname.includes('/collections/');
    const hasFilters = urlParams.has('filter') ||
                      urlParams.has('sort_by') ||
                      Array.from(urlParams.keys()).some(key => key.startsWith('filter.'));
    const isFilteringCollection = isCollectionPage && hasFilters;

    // Verificar se region_id é null, undefined, vazio ou "null" como string
    const isRegionIdInvalid = !regionId || regionId === 'null' || regionId === 'undefined' || regionId.trim() === '';

    // Verificar se o region_id foi removido manualmente da URL
    const wasRegionIdRemoved = urlParams.has('region_id') && isRegionIdInvalid;

    // Se region_id foi removido manualmente, permitir seleção de nova região
    if (wasRegionIdRemoved) {
      // Limpar localStorage para permitir nova seleção
      if (storedRegion) {
        localStorage.removeItem('selectedRegion');
      }

      // Marcar que o modal foi aberto pela nossa validação
      this.regionModalOpenedByValidation = true;

      // Abrir modal para seleção de nova região
      setTimeout(() => {
        this.openRegionSelector();
      }, 100);
      return;
    }

    // SEMPRE preservar localStorage durante buscas - NUNCA remover
    if (isSearchPage && storedRegion) {
      if (isRegionIdInvalid) {
        // Restaurar region_id na URL se foi removido durante busca
        this.preserveRegionInUrl(storedRegion);
        return;
      }
      // Se há region_id válido na URL durante busca, não fazer nada
      return;
    }

    if (isFilteringCollection && storedRegion) {
      if (isRegionIdInvalid) {
        this.preserveRegionInUrl(storedRegion);
        return;
      }
      return;
    }

    if (isRegionIdInvalid) {
      // Só processar validação de modal se NÃO estivermos numa busca
      if (!isSearchPage) {
        // Limpar localStorage apenas se não estamos numa busca
        if (storedRegion) {
          localStorage.removeItem('selectedRegion');
        }

        // Marcar que o modal foi aberto pela nossa validação
        this.regionModalOpenedByValidation = true;

        // Usar setTimeout para evitar conflitos com outros scripts
        setTimeout(() => {
          this.openRegionSelector();
        }, 100);
      }
    } else {
      // Se há region_id válido na URL, resetar a flag
      this.regionModalOpenedByValidation = false;
    }
  }

  preserveRegionInUrl(regionId) {
    // Adicionar region_id à URL sem recarregar a página
    const url = new URL(window.location);
    url.searchParams.set('region_id', regionId);
    window.history.replaceState({}, '', url.toString());
  }

  getCurrentRegionId() {
    // BLINDAGEM (fix Safari): esta função roda no caminho quente da busca
    // (getSearchResults). Alguns Safari lançam ao acessar localStorage (navegação
    // privada / ITP). Nunca pode lançar — no pior caso retorna null e a busca segue.
    try {
      // Priorizar region_id da URL, depois localStorage
      const urlParams = new URLSearchParams(window.location.search);
      const regionIdFromUrl = urlParams.get('region_id');
      let regionIdFromStorage = null;
      try {
        regionIdFromStorage = localStorage.getItem('selectedRegion');
      } catch (e) {
        regionIdFromStorage = null;
      }

      // Verificar se o region_id da URL é válido
      const isUrlRegionValid = regionIdFromUrl &&
                             regionIdFromUrl !== 'null' &&
                             regionIdFromUrl !== 'undefined' &&
                             regionIdFromUrl.trim() !== '';

      if (isUrlRegionValid) {
        return regionIdFromUrl;
      }

      // Se URL não tem region_id válido, usar localStorage
      if (regionIdFromStorage) {
        return regionIdFromStorage;
      }

      return null;
    } catch (e) {
      return null;
    }
  }

  openRegionSelector() {
    const regionSelectorTrigger = document.getElementById('region-selector-trigger');
    if (regionSelectorTrigger) {
      const detailsElement = regionSelectorTrigger.closest('details');
      if (detailsElement && !detailsElement.hasAttribute('open')) {
        detailsElement.setAttribute('open', '');

        // Inicializar o select com a região atual se existir
        setTimeout(() => {
          this.initializeRegionSelect();
        }, 100);

        // Adicionar listener para detectar quando o modal é fechado
        if (this.regionModalOpenedByValidation) {
          this.setupModalCloseListener(detailsElement);
        }
      }
    }
  }

  initializeRegionSelect() {
    const regionSelect = document.getElementById('region-selector');
    if (!regionSelect) {
      console.log('Select de região não encontrado');
      return;
    }

    // Verificar se há região na URL ou localStorage
    const currentRegion = this.getCurrentRegionId();

    console.log('Inicializando select de região. Região atual:', currentRegion);

    if (currentRegion) {
      // Definir valor no select se a região existe
      const optionExists = regionSelect.querySelector(`option[value="${currentRegion}"]`);
      if (optionExists) {
        regionSelect.value = currentRegion;
        console.log('Região definida no select:', currentRegion);
      } else {
        // Se a opção não existe, resetar para placeholder
        regionSelect.value = '';
        console.log('Opção de região não encontrada, resetando para placeholder');
      }
    } else {
      // Sem região, definir para placeholder
      regionSelect.value = '';
      console.log('Sem região definida, usando placeholder');
    }

    // Garantir que o select está visualmente atualizado
    regionSelect.dispatchEvent(new Event('change', { bubbles: true }));

    // Forçar atualização visual após um delay
    setTimeout(() => {
      regionSelect.dispatchEvent(new Event('focus'));
      regionSelect.dispatchEvent(new Event('blur'));
    }, 50);
  }

  setupModalCloseListener(detailsElement) {
    // Observer para detectar quando o modal é fechado
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (!detailsElement.hasAttribute('open') && this.regionModalOpenedByValidation) {
            // Modal foi fechado, verificar se ainda precisa estar aberto
            const urlParams = new URLSearchParams(window.location.search);
            const regionId = urlParams.get('region_id');
            const isRegionIdInvalid = !regionId || regionId === 'null' || regionId === 'undefined' || regionId.trim() === '';

            if (isRegionIdInvalid) {
              setTimeout(() => {
                this.openRegionSelector();
              }, 50);
            } else {
              this.regionModalOpenedByValidation = false;
            }
          }
        }
      });
    });

    observer.observe(detailsElement, {
      attributes: true,
      attributeFilter: ['open']
    });

    // Armazenar o observer para limpeza posterior
    this.modalCloseObserver = observer;
  }

  // Método para limpar observers quando necessário
  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.modalCloseObserver) {
      this.modalCloseObserver.disconnect();
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      var groupsWrapper = this.querySelector('#predictive-search-results-groups-wrapper');
      if (groupsWrapper) groupsWrapper.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement ? searchForTextElement.innerText : undefined;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    // Preservar region_id durante a busca
    const currentRegionId = this.getCurrentRegionId();
    let searchURL = `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`

    if(currentRegionId) {
      searchURL = `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&region_id=${currentRegionId}`
    }

    fetch(searchURL, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error && error.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    const sectionHeader = document.querySelector('.section-header');
    const headerBottom = sectionHeader ? sectionHeader.getBoundingClientRect().bottom : 0;
    this.resultsMaxHeight = window.innerHeight - headerBottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);
